module.exports = __webpack_public_path__ + "static/media/en-US.a7b6e47e.png";